angular.module('admin.directives')

.directive('officeSelector', ['BrokerageService', 'PageNotificationService', function(BrokerageService, PageNotificationService){
  return {
    controllerAs: 'officeSelectorCtrl',
    bindToController: {
      'brokerageId': '='
    },
    scope: { },
    restrict: 'A',
    template: `
    <option value="">Select...</option>
    <option ng-repeat="office in officeSelectorCtrl.offices" value="{{office.id}}" track-by="office.id">
      {{office.name}}
    </option>
    `,
    controller: function(){
      let ctrl = this;

      BrokerageService.getOffices(ctrl.brokerageId)
        .then((offices) => {
          ctrl.offices = offices;
        })
        .catch((e) => {
          PageNotificationService.error('Error retrieving all offices', e);
        });
    }
  }
}]);
